import React, { useState } from "react";
import "./MenuSlider.scss";
import arrow from "../../assets/icons/arrow-green.svg"
import { getCurrencyFormat, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { useSelector } from "react-redux";

const MenuSlider = ({ items, currentIndex, setCurrentIndex, nextSlide, prevSlide }) => {
    const totalSlides = 7;
    const { currency
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);


    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };

    return (
        <div className="MenuSlider-container">
            <div className="MenuSlider-container-slide">
                <div className="arrow left" onClick={prevSlide}>
                    <img alt="" src={arrow} />
                </div>

                <div className="MenuSliderImge">
                    {items.map((item, idx) => (
                        <div className="MenuSlider-item" key={idx}>
                            <img alt="" src={item?.ImageURL !== "" ? item?.ImageURL : "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="} className="MenuSlider-item-image" />
                            <div className="MenuSlider-item-container" >
                                <div className="MenuSlider-item-container-title">
                                    {item?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                                </div>
                                <div className="MenuSlider-item-container-description">
                                    {item?.Description?.en?.toCapitalFirst()}
                                </div>
                                <div className="MenuSlider-item-container-pricecont">
                                    <div className="MenuSlider-item-container-price">
                                        {getThePrice(item?.PriceInfo?.Price)}
                                    </div>
                                    <div className="MenuSlider-item-container-button">
                                        Order Now
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

                <div className="arrow right" onClick={nextSlide}>
                    <img alt="" src={arrow} />
                </div>

            </div>
            <div className="MenuSlider-container-dots">
                {Array.from({ length: totalSlides }).map((_, idx) => (
                    <span
                        key={idx}
                        className={`dot ${currentIndex === idx ? "active" : ""}`}
                        onClick={() => setCurrentIndex(idx)}
                    />
                ))}
            </div>
        </div>
    );
};

export default MenuSlider;
